<template>
  <sdPageHeader :title="$t('pages.menus.title-list')">
    <template v-slot:buttons>
      <div class="page-header-actions">
        <sdButton size="small" type="primary" @click="modalShow()">
          <sdFeatherIcons type="plus" size="14" />
          {{ $t('pages.apps.add-new') }}
        </sdButton>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards>
      <div>
        <a-table
          :pagination="{
            pageSize: this.filter.pageSize,
            showSizeChanger: true,
            total: this.filter.total,
            current: this.filter.current,
          }"
          @change="onTableChange"
          :columns="columns"
          :data-source="records"
          size="small"
          :loading="isLoading"
        >
          <template #icon="{ record }"> <sdFeatherIcons :type="record.icon" size="14" /> {{ record.icon }} </template>
          <template #action="{ record }">
            <a-space>
              <router-link :to="'/menus/detail/' + record.id">
                <a-button type="primary">
                  <template #icon> <sdFeatherIcons type="edit" style="color: white" /> </template>
                </a-button>
              </router-link>
              <a-button @click="del(record.id)" type="primary">
                <template #icon> <sdFeatherIcons type="trash-2" /> </template>
              </a-button>
            </a-space>
          </template>
        </a-table>
      </div>
    </sdCards>
  </Main>
  <a-modal :width="600" v-model:visible="modalVisible" title="Yeni Menü Ekle" :footer="null">
    <a-form layout="vertical" :model="newData" @submit="set">
      <a-row :gutter="15">
        <a-col :span="12">
          <a-form-item :label="$t('pages.menus.title-tr')">
            <a-input v-model:value="newData.title_tr" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.menus.title -en')">
            <a-input v-model:value="newData.title_en" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.menus.link')">
            <a-input v-model:value="newData.link_name" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label="$t('pages.menus.parent-category')">
            <a-select v-model:value="newData.parent" style="width: 100%" @change="handleChange">
              <a-select-option :value="0"> {{ $t('pages.menus.main-category') }} </a-select-option>
              <a-select-option v-for="category in mainCategories" :key="category" :value="category.id">
                {{ category.title[$store.state.i18n.i_lang] }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item>
            <template #label>
              {{ $t('pages.menus.icon') }}
              <a href="https://feathericons.com/" target="_blank"
                >Feather <sdFeatherIcons type="external-link" size="13" />
              </a>
            </template>
            <a-input v-model:value="newData.icon" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('pages.menus.rank')">
            <a-input v-model:value="newData.rank" />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label="$t('pages.menus.status')">
            <a-switch v-model:checked="newData.is_active" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item>
        <a-button type="primary" :loading="iconLoading" html-type="submit"> {{ $t('common.save') }} </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { Main } from '@/view/styled';

export default {
  name: 'menuList',
  components: {
    Main,
  },
  data() {
    return {
      isLoading: true,
      modalVisible: false,
      iconLoading: false,
      newData: {
        title_tr: '',
        title_en: '',
        link_name: '',
        parent: 0,
        icon: '',
        rank: '',
        is_active: true,
      },
      filter: {
        current: 1,
        pageSize: 10,
        total: null,
      },
      records: [],
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          key: 'id',
          width: 100,
        },
        {
          title: this.$t('common.title'),
          dataIndex: 'title',
          key: 'title',
          ellipsis: true,
        },
        {
          title: this.$t('pages.menus.parent-category'),
          dataIndex: 'parent_title',
          key: 'parent_title',
          ellipsis: true,
        },
        {
          title: this.$t('pages.menus.icon'),
          dataIndex: 'icon',
          key: 'icon',
          slots: { customRender: 'icon' },
        },
        {
          title: this.$t('pages.menus.rank'),
          dataIndex: 'rank',
          key: 'rank',
        },
        {
          title: this.$t('common.action'),
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
      mainCategories: [],
    };
  },
  methods: {
    get() {
      this.isLoading = true;
      var _this = this;
      this.$appAxios.post(this.$endpoints.menu_table_get, this.filter).then((resp) => {
        if (resp.data.status) {
          var _this = this;
          _this.records = [];
          _this.filter.total = resp.data.data.count;
          resp.data.data.data.forEach(function (item, index) {
            _this.records.push({
              key: item.id,
              id: item.id,
              title: item.detail[_this.$store.state.i18n.i_lang],
              parent_title: item.parent == 0 ? '--' : item.parent_detail.title[_this.$store.state.i18n.i_lang],
              icon: item.icon,
              rank: item.rank,
            });
          });
          this.isLoading = false;
        }
      });
    },
    getMainCategories() {
      this.$appAxios.get(this.$endpoints.manu_main_get).then((resp) => {
        this.mainCategories = resp.data.data;
      });
    },
    set() {
      this.iconLoading = true;
      this.$appAxios.post(this.$endpoints.menu_set, this.newData).then((resp) => {
        if (resp.data.status == true) {
          this.get();
          this.$message.success(this.$t('common.success-message'));
          this.modalVisible = false;
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
        this.iconLoading = false;
      });
    },
    del(id) {
      if (!confirm(this.$t('common.confirm-delete'))) {
        return;
      }

      this.$appAxios.post(this.$endpoints.menu_delete, { id: id }).then((resp) => {
        if (resp.data.status) {
          this.get();
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.error(this.$t('common.error-message'));
        }
      });
    },
    onClickFilter() {
      this.filter.current = 1;
      this.get();
    },
    onTableChange(e) {
      this.filter.current = this.isFilterNew ? 1 : e.current;
      this.filter.pageSize = e.pageSize;
      this.get();
    },
    modalShow() {
      this.modalVisible = true;
      this.getMainCategories();
    },
  },
  created() {
    this.get();
  },
};
</script>